import React, { useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import "../../style.css";
import { Card, Col, Form, Row, Button, TabContent, TabPane } from "reactstrap";
import Search from "./tabs/search";
import Register from "./tabs/register";
import { useSelector } from "react-redux";
import * as controller from "../../controllers/comissaoController";
import * as actions from "../../store/modules/comissao/actions";
import Breadcrumb from "../../components/breadcrumbs";
import { notifyWarn } from "../../components/message/message";

export default function Comissao() {
  const {
    registros,
    copia,
    activeTab,
    seeRegister,
    permitions,
    tiposComissaoBanco,
  } = useSelector((state) => state.comissao);

  useEffect(() => {
    abrirTabelaRedirecionada();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function abrirTabelaRedirecionada() {
    const params = new URLSearchParams(window.location.search);
    const bancoId = params.get("bancoId");
    const codigoTabela = params.get("codigoTabela") || "";

    if (!bancoId) {
      return actions.setActiveTab("Search");
    }

    actions.setSeeRegister(false);

    if (codigoTabela) {
      const id = await controller.getIdTabelaPorCodigo(
        bancoId,
        codigoTabela,
        params.get("dataReferencia")
      );
      if (id && (await controller.getById(id))) {
        return actions.setActiveTab("Register");
      }
      notifyWarn(
        `Nenhuma tabela com o código "${codigoTabela}" foi encontrada para a instituição. Cadastre a tabela para corrigir a inconsistência.`
      );
    }

    actions.cleanRegister();
    actions.setRegistros({
      id: "",
      descricao: "",
      codigoTabela,
      bancoId,
      produtoBancoId: "0",
      convenioBancoId: "0",
      tipoOperacaoBancoId: "0",
      dtInicioVig: "",
      dtFimVig: "",
      tabelaComissaoEventos: [],
    });
    actions.setActiveTab("Register");
  }

  async function saveItem() {
    const salvou =
      registros.id === ""
        ? await controller.create(registros, tiposComissaoBanco)
        : await controller.update(registros, copia, tiposComissaoBanco);
    if (salvou) {
      actions.cleanEventos(true);
    }
  }
  function changeTab(tab) {
    actions.setActiveTab(tab);
    actions.cleanRegister();
  }

  function seeRegisterF() {
    if (registros.id !== "") {
      actions.cleanRegister();
    }
    actions.setSeeRegister(false);
    actions.cleanEventos(true);
  }

  return (
    <>
      <Col>
        <Breadcrumb activeTab={activeTab} />
        <Card>
          <Form>
            {activeTab === "Search" ? (
              permitions.criar && (
                <Col md={12}>
                  <Row className="pt-2 pb-2">
                    <Col md={8}>
                      <Button
                        onClick={() => changeTab("Register")}
                        style={{ width: "210px" }}
                        className="purpleButton"
                      >
                        Cadastrar Tabela de Comissão
                      </Button>
                    </Col>
                  </Row>
                </Col>
              )
            ) : (
              <Col className="pt-2 pb-2">
                <Button
                  onClick={() => {
                    changeTab("Search");
                    seeRegisterF();
                  }}
                  style={{ width: "150px", color: "white" }}
                  className="purpleButton"
                >
                  <IoIosArrowBack style={{ marginTop: "3px", float: "left" }} />{" "}
                  Voltar
                </Button>
                {!seeRegister && (
                  <Button
                    onClick={() => saveItem()}
                    style={{ width: "242px", float: "right" }}
                    className="purpleButton"
                  >
                    Salvar Cadastro
                  </Button>
                )}
              </Col>
            )}
          </Form>
        </Card>
      </Col>

      <TabContent style={{ width: "100%" }} activeTab={activeTab}>
        <TabPane tabId="Search">
          <br />
          <Search />
        </TabPane>
        <TabPane tabId="Register">
          <br />
          <Register />
        </TabPane>
      </TabContent>
    </>
  );
}
